angular.module('env.data.repos.customers', [])

    .service("customersRepository", function (rest) {
        var _this = this;
        var modelType = "CustomerModel";
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get customers
         * @returns {!Promise.<Array.<RepresentationModel>>} Promise of customers collection
         */
        _this.getCustomers = function () {
            return rest.map(modelDefinition).willReturn(modelType).get();
        };

        /**
         * Get customer by id
         * @param {string} id id of the customer
         * @returns {!Promise.<RepresentationModel>} Promise of customer
         */
        _this.getCustomer = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("CustomerModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;
